document.addEventListener("DOMContentLoaded", function () {
  const previews = document.querySelectorAll(".solution-pack-preview");

  if (!previews.length) return;

  const lightbox = document.createElement("div");
  lightbox.className = "pack-lightbox";
  lightbox.setAttribute("aria-hidden", "true");

  lightbox.innerHTML = `
    <button
      class="pack-lightbox-close"
      type="button"
      aria-label="Cerrar imagen"
    >
      ×
    </button>

    <img
      class="pack-lightbox-image"
      src=""
      alt=""
    >
  `;

  document.body.appendChild(lightbox);

  const largeImage = lightbox.querySelector(".pack-lightbox-image");
  const closeButton = lightbox.querySelector(".pack-lightbox-close");
  let lastPreview = null;

  function openLightbox(preview) {
    const image = preview.querySelector(".solution-pack-image");

    if (!image) return;

    lastPreview = preview;

    largeImage.src = image.currentSrc || image.src;
    largeImage.alt = image.alt;

    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";

    closeButton.focus();
  }

  function closeLightbox() {
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";

    if (lastPreview) {
      lastPreview.focus();
    }
  }

  previews.forEach(function (preview) {
    preview.addEventListener("click", function () {
      openLightbox(preview);
    });

    preview.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        openLightbox(preview);
      }
    });
  });

  closeButton.addEventListener("click", closeLightbox);

  lightbox.addEventListener("click", function (event) {
    if (event.target === lightbox) {
      closeLightbox();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && lightbox.classList.contains("is-open")) {
      closeLightbox();
    }
  });
});